// FILE 16: src/components/ui/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css';

/**
 * @param {string}  [message]   - optional label shown below spinner
 * @param {'sm'|'md'|'lg'} [size] - spinner size variant
 * @param {string}  [className] - extra class on the wrapper
 */
export default function LoadingSpinner({ message, size = 'md', className = '' }) {
  return (
    <div className={`spinner-wrap ${className}`.trim()}>
      <div
        className={`spinner spinner--${size}`}
        role="status"
        aria-label={message || 'Loading'}
      />
      {message && <p className="spinner__message">{message}</p>}
    </div>
  );
}
